import { Plus } from "lucide-react";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

function CategoryCard({ item }) {

  const navigate = useNavigate();
  
  return (
    <div className="custom-category-card">
      <div className="custom-category-image-container "    onClick={()=>navigate(`/categories/${item?.slugPath || item?.slug}`)}
>
        {item?.image && (
        <img src={item.image} alt={item.name} className="custom-category-img" />

        )}

        {/* Text Overlay - Bottom Left */}
        <div className="custom-category-text-overlay">
          <Link to={`/categories/${item?.slugPath || item?.slug}`} className="custom-category-name text-decoration-none">{item.name}</Link>
          <p className="custom-category-desc">{item.description}</p>
        </div>

        {/* Subtle Gradient for readability */}
        <div className="custom-category-gradient"></div>
      </div>
    </div>
  );
}

export default CategoryCard;